export function isJpnAndPngUtils(fileName: string): boolean {
    const extensions: string[] = ['.jpg', '.jpeg', '.png'];
    return extensions.some((ext) => fileName.toLowerCase().endsWith(ext));
}